import { request } from "./request"
import GlobalConfig from '@/global/config'

// 查询明察暗访项目列表
export function getMcafList(params) {
    return request({
        url: '/jc-api/apps/allList',
        method: 'GET',
        params
    })
}

// 删除明察暗访
export function deleteMcafPro(id) {
    return request({
        url: '/jc-api/apps/' + id,
        method: 'DELETE',
        params: { token: GlobalConfig.getBaseToken(), }

    })
}

// 查询进入明察暗访的跳转地址
export function getMcafUrl(id) {
    return request({
        url: `/jc-api/apps/${id}/informationStorage/my?token=${GlobalConfig.getBaseToken()}&purpose=redirect`,
        method: 'GET',

    })
}

// 发布/关闭明察暗访项目
export function updataMcaf(id,data) {
    return request({
        url: `/jc-api/apps/${id}?token=${GlobalConfig.getBaseToken()}`,
        method: 'PUT',
        data

    })
}